<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 6C2 3.791 3.791 2 6 2H14C16.209 2 18 3.791 18 6V14C18 16.209 16.209 18 14 18H6C3.791 18 2 16.209 2 14V6ZM4 14C4 15.105 4.895 16 6 16H8C9.105 16 10 15.105 10 14V6C10 4.895 9.105 4 8 4H6C4.895 4 4 4.895 4 6V14Z" fill="currentColor"/>
</svg>
